export default "__VITE_ASSET__47df6fac__"